import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    regionProvinceChannel = new Subject();
    regionCityChannel = new Subject();
    workUnitChannel = new Subject();
    rankChannel = new Subject();
    createChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchWorkUnit = async (query) => {
        this.workUnitChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchWorkUnit(query).then((result) => {
            this.workUnitChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.workUnitChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRank = async (query) => {
        this.rankChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchRank(query).then((result) => {
            this.rankChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.rankChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default CreateBloc